/* Spejder Sport — packing-list article "Download PDF" (Emil 2026-08-12,
 * option B: client-side generation, no per-article PDF authoring).
 *
 * Any `[data-packing-pdf]` button (rendered by spejder-article-blocks.liquid
 * for checklist/rich_text blocks whose pdf_url setting is BLANK — a filled
 * pdf_url stays a plain link as the editor override) generates ONE pdf of the
 * WHOLE page's packing list: article title + every checklist block's heading
 * and items, drawn checkbox squares in front of each item (WinAnsi has no ☐
 * glyph — jsPDF standard fonts cover the Danish æøå but not that box).
 *
 * jsPDF loading mirrors assets/spejder-member-dashboard.js exactly: the bundled
 * UMD vendor-jspdf.js is lazy-loaded on first click, its URL resolved from
 * THIS script's own tag (no hardcoded theme paths, no CDN).
 */
(function () {
  'use strict';

  var jsPDFLoaded = false;
  var jsPDFLoading = false;
  var jsPDFCallbacks = [];

  function loadJsPDF(callback) {
    if (jsPDFLoaded) {
      callback();
      return;
    }
    jsPDFCallbacks.push(callback);
    if (jsPDFLoading) return;
    jsPDFLoading = true;

    var anyAsset = document.querySelector('script[src*="spejder-packing-pdf.js"]');
    if (!anyAsset) {
      console.warn('[spejder-packing-pdf] cannot resolve vendor-jspdf.js — anchor script missing');
      jsPDFLoading = false;
      jsPDFCallbacks = [];
      return;
    }

    var script = document.createElement('script');
    script.src = anyAsset.src.replace('spejder-packing-pdf.js', 'vendor-jspdf.js');
    script.onload = function () {
      jsPDFLoaded = true;
      jsPDFLoading = false;
      jsPDFCallbacks.forEach(function (cb) { cb(); });
      jsPDFCallbacks = [];
    };
    script.onerror = function () {
      jsPDFLoading = false;
      jsPDFCallbacks = [];
      console.warn('[Spejder] vendor-jspdf.js failed to load — packing-list PDF unavailable');
    };
    document.head.appendChild(script);
  }

  function collectChecklists() {
    var sections = [];
    document.querySelectorAll('.spejder-checklist').forEach(function (list) {
      var heading = list.querySelector('.spejder-checklist__heading');
      var items = [];
      list.querySelectorAll('.spejder-checklist__list li').forEach(function (li) {
        var t = (li.textContent || '').trim();
        if (t) items.push(t);
      });
      if (items.length) {
        sections.push({ heading: heading ? heading.textContent.trim() : '', items: items });
      }
    });
    return sections;
  }

  function generatePDF() {
    var jsPDFCtor = (window.jspdf && window.jspdf.jsPDF) || window.jsPDF;
    if (!jsPDFCtor) return;

    var sections = collectChecklists();
    if (!sections.length) return;

    var titleEl = document.querySelector('.spejder-article__title, h1');
    var title = titleEl ? titleEl.textContent.trim() : 'Pakkeliste';

    var doc = new jsPDFCtor({ unit: 'mm', format: 'a4' });
    var pageH = doc.internal.pageSize.getHeight();
    var margin = 20;
    var y = margin;

    function ensureRoom(needed) {
      if (y + needed > pageH - margin) {
        doc.addPage();
        y = margin;
      }
    }

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    var titleLines = doc.splitTextToSize(title, 170);
    doc.text(titleLines, margin, y);
    y += titleLines.length * 7 + 6;

    sections.forEach(function (section) {
      ensureRoom(14);
      if (section.heading) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(12);
        doc.text(section.heading, margin, y);
        y += 7;
      }
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      section.items.forEach(function (item) {
        var lines = doc.splitTextToSize(item, 160);
        ensureRoom(lines.length * 5 + 1.5);
        /* drawn checkbox square — baseline-aligned with the first line */
        doc.rect(margin, y - 3.2, 3.5, 3.5);
        doc.text(lines, margin + 6, y);
        y += lines.length * 5 + 1.5;
      });
      y += 5;
    });

    var filename = title
      .toLowerCase()
      .replace(/[æå]/g, 'a').replace(/ø/g, 'o')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'pakkeliste';
    doc.save(filename + '.pdf');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-packing-pdf]');
    if (!btn) return;
    e.preventDefault();
    loadJsPDF(generatePDF);
  });
})();
